// Impersonation banner (`imb-`). Deliberately NOT glass, unlike almost every other surface in this app:
// this is a system state, not a piece of UI, and it has to read as one at a glance. Solid, high-contrast,
// amber/rose, full-bleed across the top, above everything including react-modal's overlay.
//
// The `imb-offset` class is put on <html> while a banner is showing, so the band never covers the app's own
// fixed chrome (headers, the solve-pane rails). Padding on <html> rather than <body> because several
// screens set their own body-level layout.
export const impersonationBannerStyles = `
:root.imb-offset {
  scroll-padding-top: 44px;
}
:root.imb-offset body {
  padding-top: 44px;
}

.imb-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  /* Above react-modal's overlay (1000-range in this app) so the banner is never hidden behind a dialog —
     an impersonated session must be legible from every screen, including modal ones. */
  z-index: 100000;
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 44px;
  padding: 6px 16px;
  box-sizing: border-box;
  background: linear-gradient(90deg, #b45309 0%, #9f1239 100%);
  color: #fff7ed;
  font-size: 14px;
  font-weight: 600;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.25);
}

.imb-icon {
  flex: 0 0 auto;
  font-size: 16px;
  line-height: 1;
}

.imb-text {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.imb-role {
  flex: 0 0 auto;
  padding: 2px 8px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.18);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.02em;
}

.imb-return {
  flex: 0 0 auto;
  border: 1px solid rgba(255, 255, 255, 0.55);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.12);
  color: #fff7ed;
  font-size: 13px;
  font-weight: 700;
  padding: 6px 12px;
  cursor: pointer;
}

.imb-return:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.24);
}

.imb-return:disabled {
  opacity: 0.6;
  cursor: default;
}

/* Below the pill-and-button width the label is the first thing to give: the ROLE and the way out matter
   more than the name when there is no room for all three. */
@media (max-width: 560px) {
  .imb-text {
    font-size: 13px;
  }
  .imb-role {
    display: none;
  }
}
`;
